import { useSelector } from 'react-redux';

import { selectAIState } from '../store/aiSlice';
import { AIState } from '../service/ai.interface';

export const useAiProfile = (): AIState => useSelector(selectAIState);
